import type { UnlikelyVariant } from "@unlikelystudio/commerce-connector"

import type { Nullish } from "~/@types/generics"
import { OPTION_COLOR } from "~/components/ui/Product/ProductHeader/_data/constants"

export function getVariantColor(variant: Nullish<Pick<UnlikelyVariant, "selectedOptions">>) {
  return variant?.selectedOptions?.find((option) => option.name === OPTION_COLOR)?.value ?? null
}
